import React, { useState } from "react";
import {
  Container,
  Pagination,
  Select,
  MenuItem,
  InputLabel,
  Grid,
  TextField,
  Button,
  Checkbox,
  Rating,
  Slider,
} from "@mui/material";

import { HeaderComp, SupplierCards } from "components";
import {
  FilterList,
  LocationOn,
  MyLocation,
  Search,
  Sort,
} from "@mui/icons-material";
import { useSuppliers } from "hooks/useDataFetch";
import { useIsMounted } from "hooks";
import { useEffect } from "react";
import { emptyList, pageLoading } from "asset/animations";
import Lottie from "react-lottie";
import PlacesAutocomplete, {
  geocodeByAddress,
  getLatLng,
} from "react-places-autocomplete";
import Geocode from "react-geocode";
import { WithGeocode } from "App";

const OrderNow = () => {
  WithGeocode();
  const [sortBy, setSortBy] = useState("recommended");

  const handleSort = (event) => {
    setSortBy(event.target.value);
  };

  const [filterSupplier, setFilterSupplier] = useState([]);
  const [sortSupplier, setSortSupplier] = useState([]);

  const [ratingFilter, setRatingFilter] = useState(0);
  const [priceFilter, setPriceFilter] = useState(0);
  const [searchLocation, setSearchLocation] = useState("");
  const [currentLocation, setCurrentLocation] = useState({
    lat: "",
    lng: "",
    address: "",
  });
  const [currentCoordinates, setCurrentCoordinates] = useState({
    lat: "",
    lng: "",
  });

  const [deliveryType, setDeliveryType] = useState("");

  const [searchSupplier, setSearchSupplier] = useState("");

  const [paymentMethod, setPaymentMethod] = useState({
    cash: false,
    card: false,
  });

  const [filter, setFilter] = useState(false);
  const [sort, setSort] = useState(false);

  const suppliers = useSuppliers();

  const isMounted = useIsMounted();

  //filter products

  // console.log(currentLocation);

  useEffect(() => {
    if (isMounted?.current) {
      const filterLocation = suppliers?.data?.filter((item) => {
        if (currentLocation?.address) {
          return currentLocation?.address
            ?.toLowerCase()
            .includes(item?.location?.toLowerCase());
        } else {
          return suppliers?.data;
        }
      });

      const filterDeliveryType = filterLocation?.filter((item) => {
        if (deliveryType) {
          return item.supplierType
            .toLowerCase()
            .includes(deliveryType.toLowerCase());
        } else {
          return filterLocation;
        }
      });
      const filterSupplier = filterDeliveryType?.filter((item) => {
        if (searchSupplier) {
          return item?.name
            ?.toLowerCase()
            .includes(searchSupplier?.toLowerCase());
        } else {
          return filterDeliveryType;
        }
      });
      const paymentMethodFilter = filterSupplier?.filter((item) => {
        if (paymentMethod.cash && !paymentMethod.card) {
          return item.payments.cash;
        } else if (paymentMethod.card && !paymentMethod.cash) {
          return item.payments.card;
        } else {
          return filterSupplier;
        }
      });
      const filterRating = paymentMethodFilter?.filter((item) => {
        if (ratingFilter > 0) {
          return item.rating === parseInt(ratingFilter);
        } else {
          return paymentMethodFilter;
        }
      });
      const filterPrice = filterRating?.filter((item) => {
        if (priceFilter > 0) {
          return item.minOrder >= priceFilter;
        } else {
          return filterRating;
        }
      });
      // console.log(filterPrice);
      setFilterSupplier(filterPrice);
    }
  }, [
    suppliers?.data,
    isMounted,
    ratingFilter,
    priceFilter,
    currentLocation,
    deliveryType,
    paymentMethod,
    searchSupplier,
  ]);

  //sort suppliers

  useEffect(() => {
    if (isMounted.current) {
      if (filterSupplier?.length > 0) {
        if (sortBy === "recommended") {
          return setSortSupplier([...filterSupplier]);
        } else if (sortBy === "new") {
          return setSortSupplier(
            [...filterSupplier].sort((a, b) => a.createdAt - b.createdAt)
          );
        } else if (sortBy === "highToLow") {
          return setSortSupplier(
            [...filterSupplier].sort((a, b) => b.minOrder - a.minOrder)
          );
        } else if (sortBy === "lowToHigh") {
          return setSortSupplier(
            [...filterSupplier].sort((a, b) => a.minOrder - b.minOrder)
          );
        } else if (sortBy === "rating") {
          return setSortSupplier(
            [...filterSupplier].sort((a, b) => b.rating - a.rating)
          );
        } else if (sortBy === "popularity") {
          return setSortSupplier(
            [...filterSupplier].sort((a, b) => b.reviews - a.reviews)
          );
        } else if (sortBy === "atoz") {
          return setSortSupplier(
            [...filterSupplier].sort((a, b) => a.name.localeCompare(b.name))
          );
        } else {
          return setSortSupplier(
            [...filterSupplier].sort((a, b) => b.name.localeCompare(a.name))
          );
        }
      } else {
        return setSortSupplier([]);
      }
    }
  }, [isMounted, filterSupplier, sortBy]);

  // console.log(searchLocation);
  // console.log(paymentMethod);
  // console.log(ratingFilter);
  // console.log(priceFilter);
  // console.log(sortSupplier);
  // console.log(suppliers?.loading);

  const notFoundLottie = {
    loop: false,
    autoplay: true,
    animationData: emptyList,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };
  const LoadingPageLottie = {
    loop: true,
    autoplay: true,
    animationData: pageLoading,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  const resetFilter = () => {
    setRatingFilter(0);
    setPriceFilter(0);
    setSearchLocation("");
    setDeliveryType("");
    setPaymentMethod({
      cash: false,
      card: false,
    });
    setSearchSupplier("");
    setCurrentLocation({
      lat: "",
      lng: "",
      address: "",
    });
  };

  const handleCurrentLocation = () => {
    navigator.permissions.query({ name: "geolocation" }).then((result) => {
      if (result.state === "granted") {
        navigator.geolocation.getCurrentPosition((position) => {
          console.log(position);
          setCurrentCoordinates({
            lat: position.coords.latitude,
            lng: position.coords.longitude,
          });
        });
      } else {
        alert(
          "Please turn on your location or allow permission to access your location for this site."
        );
        navigator.geolocation.getCurrentPosition((position) => {
          // console.log(position);
          setCurrentCoordinates({
            lat: position.coords.latitude,
            lng: position.coords.longitude,
          });
        });
      }
    });
  };

  const handleAddressSelect = (address) => {
    geocodeByAddress(address)
      .then((results) => getLatLng(results[0]))
      .then((latLng) => {
        // console.log(address);
        setCurrentLocation({
          address: address,
          lat: latLng.lat,
          lng: latLng.lng,
        });
        setCurrentCoordinates({
          lat: latLng.lat,
          lng: latLng.lng,
        });
      })
      .catch((error) => console.error("Error", error));
  };

  useEffect(() => {
    if (isMounted.current) {
      Geocode.fromLatLng(currentCoordinates.lat, currentCoordinates.lng).then(
        (response) => {
          // console.log(response.results[0]);
          const address = response.results[0].formatted_address;
          // console.log(address);

          const pincode = response.results[0].address_components.find(
            (item) => {
              return item.types.includes("postal_code");
            }
          );

          const city = response.results[0].address_components.find((item) => {
            return item.types.includes("administrative_area_level_2");
          });

          const country = response.results[0].address_components.find(
            (item) => {
              return item.types.includes("country");
            }
          );

          setCurrentLocation({
            address:
              city?.long_name +
              ", " +
              pincode?.long_name +
              ", " +
              country?.long_name,
            lat: currentCoordinates.lat,
            lng: currentCoordinates.lng,
          });
        },
        (error) => {
          console.error(error);
        }
      );
    }
  }, [currentCoordinates, isMounted]);

  return (
    <main>
      <header>
        <HeaderComp title="Order Now" />
      </header>

      <div className="mob-filter-main">
        <div className="mobile-filter-container flex-column">
          <div className="mob-filter-location flex-row align-items-center justify-content-center gap-1">
            <LocationOn />{" "}
            <h3>{currentLocation?.address || "Select Location"}</h3>
          </div>
          {/* <div className="distribution-type flex-row align-items-center justify-content-between ">
        <span className="flex-row justify-content-center align-items-center">
          Local
        </span>
        <span className="flex-row justify-content-center align-items-center">
          International
        </span>
        <span className="flex-row justify-content-center align-items-center">
          Quick Delivery
        </span>
      </div> */}
          <div className="mob-filter-main-content flex-row align-items-center gap-2 justify-content-between">
            <div className="mob-filter-content-search-bar flex-row align-items-center gap-1 w-100">
              <span className="flex-row align-items-center">
                <Search />
              </span>
              <span className="flex-row w-100">
                <PlacesAutocomplete
                  value={currentLocation.address}
                  onChange={(address) => {
                    setCurrentLocation({ ...currentLocation, address });
                  }}
                  onSelect={handleAddressSelect}
                >
                  {({
                    getInputProps,
                    suggestions,
                    getSuggestionItemProps,
                    loading,
                  }) => (
                    <div className="w-100">
                      <TextField
                        {...getInputProps({
                          placeholder: "Search for places",
                          className: "filter-by-location-search-input",
                        })}
                      />
                      <div className="autocomplete-dropdown-container">
                        {loading && <div>Loading...</div>}
                        {suggestions.map((suggestion) => {
                          const className = suggestion.active
                            ? "suggestion-item--active"
                            : "suggestion-item";
                          // inline style for demonstration purpose
                          const style = suggestion.active
                            ? {
                                backgroundColor: "#fafafa",
                                cursor: "pointer",
                              }
                            : {
                                backgroundColor: "#ffffff",
                                cursor: "pointer",
                              };
                          return (
                            <div
                              {...getSuggestionItemProps(suggestion, {
                                className,
                                style,
                              })}
                            >
                              <span>{suggestion.description}</span>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  )}
                </PlacesAutocomplete>
              </span>
            </div>
            <div className="mob-filter-icon flex-row align-items-center gap-1">
              <span
                className="flex-row align-items-center"
                onClick={() => {
                  setFilter(!filter);
                  setSort(false);
                }}
              >
                <FilterList />
              </span>
              <span
                className="flex-row align-items-center"
                onClick={() => {
                  setFilter(false);
                  setSort(!sort);
                }}
              >
                <Sort />
              </span>
            </div>
          </div>

          <div className="filter-popup">
            {filter && (
              <div className="mob-filter-header flex-column gap-2">
                <div className="mob-filter-title flex-row align-items-center justify-content-between">
                  <h3 className="flex-row gap-2 align-items-center">
                    FILTERS <FilterList />{" "}
                  </h3>
                  <h5 className="mob-filter-title-reset" onClick={resetFilter}>
                    RESET
                  </h5>
                </div>
                <div className="mob-filter-options flex-column gap-2">
                  <div className="filter-by-location flex-column gap-1 ">
                    <span className="filter-by-location-icon justify-content-between gap-2 flex-row align-items-center">
                      <h4 className="flex-row align-items-center justify-content-between">
                        Locations
                      </h4>
                      <span className="flex-row align-items-center gap-1">
                        <span>
                          {currentLocation?.address || "Location not found"}
                        </span>
                        <Button
                          className="  flex-row align-items-center justify-content-center"
                          onClick={handleCurrentLocation}
                        >
                          <MyLocation />
                        </Button>
                      </span>
                    </span>
                    <span className=" filter-by-location-search flex-row align-items-start w-100">
                      <PlacesAutocomplete
                        value={currentLocation.address}
                        onChange={(address) => {
                          setCurrentLocation({ ...currentLocation, address });
                        }}
                        onSelect={handleAddressSelect}
                      >
                        {({
                          getInputProps,
                          suggestions,
                          getSuggestionItemProps,
                          loading,
                        }) => (
                          <div className="w-100">
                            <TextField
                              {...getInputProps({
                                placeholder: "Search for places",
                                className: "filter-by-location-search-input",
                              })}
                            />
                            <div className="autocomplete-dropdown-container">
                              {loading && <div>Loading...</div>}
                              {suggestions.map((suggestion) => {
                                const className = suggestion.active
                                  ? "suggestion-item--active"
                                  : "suggestion-item";
                                // inline style for demonstration purpose
                                const style = suggestion.active
                                  ? {
                                      backgroundColor: "#fafafa",
                                      cursor: "pointer",
                                    }
                                  : {
                                      backgroundColor: "#ffffff",
                                      cursor: "pointer",
                                    };
                                return (
                                  <div
                                    {...getSuggestionItemProps(suggestion, {
                                      className,
                                      style,
                                    })}
                                  >
                                    <span>{suggestion.description}</span>
                                  </div>
                                );
                              })}
                            </div>
                          </div>
                        )}
                      </PlacesAutocomplete>
                      <Button
                        className="filter-by-location-btn"
                        onClick={() => {
                          setCurrentLocation(searchLocation);
                        }}
                      >
                        <Search />
                      </Button>
                    </span>
                  </div>
                  <div className="filter-by-types">
                    <div className="filter-title">
                      <h4>Types</h4>
                    </div>
                    <span className="filter-by-types-businesses flex-row  align-items-center">
                      <Checkbox
                        checked={deliveryType === "local"}
                        onChange={() => setDeliveryType("local")}
                      />{" "}
                      <p>Local</p>
                    </span>
                    <span className="filter-by-types-businesses flex-row  align-items-center">
                      <Checkbox
                        checked={deliveryType === "international"}
                        onChange={() => setDeliveryType("international")}
                      />{" "}
                      <p>International</p>
                    </span>
                    <span className="filter-by-types-businesses flex-row  align-items-center">
                      <Checkbox
                        checked={deliveryType === "quick"}
                        onChange={() => setDeliveryType("quick")}
                      />{" "}
                      <p>Quick Delivery</p>
                    </span>
                  </div>
                  <div className="filter-by-searching">
                    <div className="filter-title">Search Supplier</div>
                    <div className="filter-by-searching-input flex-row align-items-center w-100">
                      <TextField
                        fullWidth
                        placeholder="Search  supplier "
                        className="w-100"
                        value={searchSupplier}
                        onChange={(e) => setSearchSupplier(e.target.value)}
                      />
                      <Button className="filter-by-searching-btn">
                        <Search />
                      </Button>
                    </div>
                  </div>
                  <div className="filter-by-payments-mode">
                    <div className="filter-title">Payment Mode</div>
                    <div className="filter-by-payments-mode-select">
                      <span className="select-payments-mode flex-row  align-items-center">
                        <Checkbox
                          checked={paymentMethod.cash}
                          onChange={(e) => {
                            setPaymentMethod(
                              e.target.checked
                                ? { ...paymentMethod, cash: true }
                                : { ...paymentMethod, cash: false }
                            );
                          }}
                        />{" "}
                        <p>Cash On Delivery</p>
                      </span>
                      <span className="select-payments-mode flex-row  align-items-center">
                        <Checkbox
                          checked={paymentMethod.card}
                          onChange={(e) => {
                            setPaymentMethod(
                              e.target.checked
                                ? { ...paymentMethod, card: true }
                                : { ...paymentMethod, card: false }
                            );
                          }}
                        />{" "}
                        <p>Pay Online</p>
                      </span>
                    </div>
                  </div>
                  <div className="filter-by-ratings">
                    <div className="filter-title">Ratings</div>
                    <div className="ratings-filter">
                      <Rating
                        name="simple-controlled"
                        value={ratingFilter}
                        onChange={(event, newValue) => {
                          setRatingFilter(newValue);
                        }}
                      />
                    </div>
                  </div>
                  <div className="filter-by-price">
                    <div className="filter-title flex-row align-items-center justify-content-between">
                      <h4>Price</h4>

                      <span> SAR {priceFilter}</span>
                    </div>

                    <div className="price-filter-bar">
                      <Slider
                        defaultValue={50}
                        value={priceFilter}
                        aria-label="Default"
                        valueLabelDisplay="auto"
                        min={10}
                        max={1000}
                        onChange={(event, newValue) => {
                          setPriceFilter(newValue);
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>

          <div className="sort-popup">
            {sort && (
              <div className="mob-sort-content w-100">
                <span className="flex-row gap-1 align-items-center order-sort-header-section-span w-100">
                  <InputLabel>Sort By</InputLabel>
                  <Select
                    value={sortBy}
                    onChange={handleSort}
                    className="order-sort-select w-100"
                    displayEmpty
                    inputProps={{ "aria-label": "Without label" }}
                  >
                    <MenuItem value="recommended">
                      <p>Recommended</p>
                    </MenuItem>
                    <MenuItem value="new">
                      <p>What's new </p>
                    </MenuItem>
                    <MenuItem value="highToLow">
                      <p>Price : High to low </p>
                    </MenuItem>
                    <MenuItem value="lowToHigh">
                      <p>Price : Low to high</p>
                    </MenuItem>
                    <MenuItem value="rating">
                      <p>Customer Rating</p>
                    </MenuItem>
                    <MenuItem value="popularity">
                      <p>Popularity</p>
                    </MenuItem>
                    <MenuItem value="atoz">
                      <p>A to Z</p>
                    </MenuItem>
                    <MenuItem value="ztoa">
                      <p>Z to A</p>
                    </MenuItem>
                  </Select>
                </span>
              </div>
            )}
          </div>
        </div>
      </div>

      <Grid container className="flex-row main-order-container ">
        <Grid
          item
          xs={0}
          sm={4}
          md={4}
          lg={3}
          className="order-main-section-left"
        >
          <div className="order-filter-header">
            <div className="order-total-item-avail flex-row align-items-center gap-1 ">
              <b>Recommended -</b> <p> {suppliers?.data?.length} items</p>
            </div>
            <div className="order-filter-title flex-row align-items-center justify-content-between">
              <h3 className="flex-row gap-2 align-items-center">
                FILTERS <FilterList />{" "}
              </h3>
              <h5 className="order-filter-title-reset" onClick={resetFilter}>
                RESET
              </h5>
            </div>
            <div className="order-filter-options">
              <div className="filter-by-location flex-column gap-1 ">
                <span className="filter-by-location-icon justify-content-between gap-2 flex-row align-items-center">
                  <h4 className="flex-row align-items-center justify-content-between">
                    Locations
                  </h4>
                  <span className="flex-row align-items-center gap-1">
                    <span>{currentLocation?.address || "Select Location"}</span>
                    <Button
                      className="  flex-row align-items-center justify-content-center"
                      onClick={handleCurrentLocation}
                    >
                      <MyLocation />
                    </Button>
                  </span>
                </span>
                <span className=" filter-by-location-search relative flex-row align-items-start">
                  <PlacesAutocomplete
                    value={currentLocation.address}
                    onChange={(address) => {
                      setCurrentLocation({ ...currentLocation, address });
                    }}
                    onSelect={handleAddressSelect}
                  >
                    {({
                      getInputProps,
                      suggestions,
                      getSuggestionItemProps,
                      loading,
                    }) => (
                      <div className="w-100">
                        <TextField
                          {...getInputProps({
                            placeholder: "Search for places",
                            className: "filter-by-location-search-input",
                          })}
                        />
                        <div className="autocomplete-dropdown-container">
                          {loading && <div>Loading...</div>}
                          {suggestions.map((suggestion, index) => {
                            const className = suggestion.active
                              ? "suggestion-item--active"
                              : "suggestion-item";
                            // inline style for demonstration purpose
                            const style = suggestion.active
                              ? {
                                  backgroundColor: "#f1f6ff",
                                  cursor: "pointer",
                                  padding: "5px",
                                }
                              : {
                                  backgroundColor: "#f1f6ff",
                                  cursor: "pointer",
                                  padding: "5px",
                                };
                            return (
                              <div
                                {...getSuggestionItemProps(suggestion, {
                                  className,
                                  style,
                                })}
                                key={index}
                              >
                                <span>{suggestion.description}</span>
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    )}
                  </PlacesAutocomplete>
                  {/* <TextField
                    placeholder="Search for places"
                    className="filter-by-location-search-input"
                    value={searchLocation}
                    onChange={(e) => setSearchLocation(e.target.value)}
                  /> */}
                  <Button
                    className="filter-by-location-btn"
                    onClick={() => {
                      setCurrentLocation(searchLocation);
                    }}
                  >
                    <Search />
                  </Button>
                </span>
              </div>
              <div className="filter-by-types">
                <div className="filter-title">
                  <h4>Types</h4>
                </div>
                <span className="filter-by-types-businesses flex-row  align-items-center">
                  <Checkbox
                    checked={deliveryType === "local"}
                    onChange={() => setDeliveryType("local")}
                  />{" "}
                  <p>Local</p>
                </span>
                <span className="filter-by-types-businesses flex-row  align-items-center">
                  <Checkbox
                    checked={deliveryType === "international"}
                    onChange={() => setDeliveryType("international")}
                  />{" "}
                  <p>International</p>
                </span>
                <span className="filter-by-types-businesses flex-row  align-items-center">
                  <Checkbox
                    checked={deliveryType === "quick"}
                    onChange={() => setDeliveryType("quick")}
                  />{" "}
                  <p>Quick Delivery</p>
                </span>
              </div>
              <div className="filter-by-searching">
                <div className="filter-title">Search Supplier</div>
                <div className="filter-by-searching-input flex-row align-items-center">
                  <TextField
                    placeholder="Search  supplier "
                    value={searchSupplier}
                    onChange={(e) => setSearchSupplier(e.target.value)}
                  />
                  <Button className="filter-by-searching-btn">
                    <Search />
                  </Button>
                </div>
              </div>
              <div className="filter-by-payments-mode">
                <div className="filter-title">Payment Mode</div>
                <div className="filter-by-payments-mode-select">
                  <span className="select-payments-mode flex-row  align-items-center">
                    <Checkbox
                      checked={paymentMethod.cash}
                      onChange={(e) => {
                        setPaymentMethod(
                          e.target.checked
                            ? { ...paymentMethod, cash: true }
                            : { ...paymentMethod, cash: false }
                        );
                      }}
                    />{" "}
                    <p>Cash On Delivery</p>
                  </span>
                  <span className="select-payments-mode flex-row  align-items-center">
                    <Checkbox
                      checked={paymentMethod.card}
                      onChange={(e) => {
                        setPaymentMethod(
                          e.target.checked
                            ? { ...paymentMethod, card: true }
                            : { ...paymentMethod, card: false }
                        );
                      }}
                    />{" "}
                    <p>Pay Online</p>
                  </span>
                </div>
              </div>
              <div className="filter-by-ratings">
                <div className="filter-title">Ratings</div>
                <div className="ratings-filter">
                  <Rating
                    name="simple-controlled"
                    value={ratingFilter}
                    onChange={(event, newValue) => {
                      setRatingFilter(newValue);
                    }}
                  />
                </div>
              </div>
              <div className="filter-by-price">
                <div className="filter-title flex-row align-items-center justify-content-between">
                  <h4>Price</h4>

                  <span> SAR {priceFilter}</span>
                </div>

                <div className="price-filter-bar">
                  <Slider
                    defaultValue={50}
                    value={priceFilter}
                    aria-label="Default"
                    valueLabelDisplay="auto"
                    min={10}
                    max={1000}
                    onChange={(event, newValue) => {
                      setPriceFilter(newValue);
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </Grid>
        <Grid
          item
          xs={12}
          sm={8}
          md={8}
          lg={9}
          className="order-main-section-right"
        >
          <Container>
            <div className="order-container">
              <div className="order-sort-header-section flex-row flex-wrap  gap-2 ">
                <span className="flex-row gap-1 align-items-center order-sort-header-section-span">
                  <InputLabel>Sort By</InputLabel>
                  <Select
                    value={sortBy}
                    onChange={handleSort}
                    className="order-sort-select"
                    displayEmpty
                    inputProps={{ "aria-label": "Without label" }}
                  >
                    <MenuItem value="recommended">
                      <p>Recommended</p>
                    </MenuItem>
                    <MenuItem value="new">
                      <p>What's new </p>
                    </MenuItem>
                    <MenuItem value="highToLow">
                      <p>Price : High to low </p>
                    </MenuItem>
                    <MenuItem value="lowToHigh">
                      <p>Price : Low to high</p>
                    </MenuItem>
                    <MenuItem value="rating">
                      <p>Customer Rating</p>
                    </MenuItem>
                    <MenuItem value="popularity">
                      <p>Popularity</p>
                    </MenuItem>
                    <MenuItem value="atoz">
                      <p>A to Z</p>
                    </MenuItem>
                    <MenuItem value="ztoa">
                      <p>Z to A</p>
                    </MenuItem>
                  </Select>
                </span>
              </div>

              <div className="order-display-card-section gap-1">
                {!suppliers?.loading ? (
                  suppliers?.data ? (
                    sortSupplier?.length > 0 ? (
                      sortSupplier?.map((data, index) => {
                        return (
                          <SupplierCards
                            key={index}
                            img={data?.image}
                            name={data?.name}
                            location={data?.location}
                            rating={data?.rating}
                            minOrder={data?.minOrder}
                            payments={data?.payments}
                            id={data?.id}
                          />
                        );
                      })
                    ) : (
                      <div
                        className="flex-row align-items-center justify-content-center "
                        style={{ minHeight: "50vh" }}
                      >
                        <div className="flex-col align-items-center justify-content-center">
                          <Lottie
                            options={notFoundLottie}
                            height={350}
                            width={350}
                          />
                          <h3>No Suppliers Found for your search</h3>
                        </div>
                      </div>
                    )
                  ) : (
                    <div
                      className="flex-row align-items-center justify-content-center "
                      style={{ minHeight: "50vh" }}
                    >
                      <div className="flex-col align-items-center justify-content-center">
                        <Lottie
                          options={notFoundLottie}
                          height={350}
                          width={350}
                        />
                        <h3>No Suppliers Found</h3>
                      </div>
                    </div>
                  )
                ) : (
                  <div
                    className="flex-row align-items-center justify-content-center "
                    style={{ minHeight: "50vh" }}
                  >
                    <Lottie
                      options={LoadingPageLottie}
                      height={200}
                      width={200}
                    />
                  </div>
                )}
              </div>
            </div>
          </Container>
        </Grid>
        {suppliers?.data?.length > 10 && (
          <div className="order-sort-footer-pagination w-100 flex-row justify-content-center">
            <Pagination
              count={Math.ceil((suppliers?.data?.length / 10).toFixed(2))}
              variant="outlined"
              shape="rounded"
            />
          </div>
        )}
      </Grid>
    </main>
  );
};

export default OrderNow;
